import { render, staticRenderFns } from "./elec_charge_manage.vue?vue&type=template&id=16fafd1f&"
import script from "./elec_charge_manage.vue?vue&type=script&lang=js&"
export * from "./elec_charge_manage.vue?vue&type=script&lang=js&"
import style0 from "./elec_charge_manage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports